import React from "react"
import Overview from "../overview"
import moment from "moment";
import PropertyFilterBar from "./propertyFilterBar"
import { getHyreferralCampaignsPropertiesBreakdown } from "relay/campaigns"
import { getCampaignsByPropertyIdsSelected } from "../utils"
import { getCreateEventPath } from "constants/path"
import { compare } from "content/utils/commonParsing"
import Loading from "storybookComponents/Loader"
import StyledTable from 'components/TableComponent';
import EmptyView from "../Components/NoPropView"
import EmptyViewCampaign from "images/EmptyViewCampaign.svg"
import TableHeader from "../Components/tableHeader"
import { getDate } from "content/utils/commonParsing";
import {
  getPropertiesRows,
  csvHeadersProperties,
  getColumnsForProperties,
  getDataForCSV
} from "../common"


const tableFilterOption = [
  {
    id: "All",
    label: "All"
  },
  {
    id: "Active",
    label: "Active"
  },
  {
    id: "Inactive",
    label: "Inactive"
  },
]

const statusOption = [
  {
    id: "all",
    value: "All"
  },
  {
    id: "active",
    value: "Active"
  },
  {
    id: "non_active",
    value: "Inactive"
  },
]
const ByProperty = ({ subMenu, subOrgDetails, propertiesOfOrg, allCampaignsByProperties, classes, history, handleSelectCampaign, setReportData, previewReport }) => {
  const [monthRange, setMonthRange] = React.useState({ startAt: moment().startOf("month"), endAt: moment().endOf("month"), label: "This Month" })
  const [selectedProperties, setSelectedProperties] = React.useState([]);
  const [selectedCampaigns, setSelectedCampaigns] = React.useState([]);
  const [campaignsForDropDown, setCampaignsForDropDown] = React.useState([]);
  const [status, setStatus] = React.useState(['active'])
  const [rows, setRows] = React.useState(null);
  const [csvData, setCsvData] = React.useState([])
  const [data, setData] = React.useState([]);
  const [loading, setLoading] = React.useState(true);
  const [showFilter, setShowFilter] = React.useState(false);
  const [tableStatusFilter, setTableStatusFilter] = React.useState(tableFilterOption[0])
  const [chartData, setChartData] = React.useState();

  const handleClickCampaign = (item) => {
    handleSelectCampaign({
      ...item,
      status: ['all'],
    })
  }

  React.useEffect(() => {
    if (previewReport) {
      let params = JSON.parse(previewReport.params)
      let propertiesParams = params.property_ids || [];
      let campaignsParams = params.campaigns_id || [];
      let statusParams = params.active_status ? [params.active_status] : ['all']
      let monthRangeParams = { startAt: moment().startOf("month"), endAt: moment().endOf("month"), label: "This Month" }
      if (params.start_date && params.end_date && params.range_label) {
        monthRangeParams = { startAt: moment(params.start_date).startOf("month"), endAt: moment(params.end_date).endOf("month"), label: params.range_label }
      }
      setSelectedProperties(propertiesParams);
      setStatus(statusParams)
      let list = getCampaignsByPropertyIdsSelected(propertiesParams, allCampaignsByProperties);
      setCampaignsForDropDown(list);
      let selectedCampaigns = [];
      for (let i = 0; i < list.length; i++) {
        let campaigns = list[i].list;
        let filteredCampaigns = campaigns.filter(value => campaignsParams.includes(value.id));
        let campaignsIds = filteredCampaigns.map(e => e.id)
        if (campaignsIds.length > 0) {
          selectedCampaigns.push({
            id: list[i].id,
            list: campaignsIds
          })
        }
      }
      setSelectedCampaigns(selectedCampaigns)
      setMonthRange(monthRangeParams);
      getPropertyBreakDown(propertiesParams, selectedCampaigns, monthRangeParams, statusParams)
    } else {
      getPropertyBreakDown([], [], monthRange, status)
    }
  }, [1])

  const getPropertyBreakDown = async (propertyIds, campaigns, monthRange, status) => {
    setLoading(true);
    let campaignsIds = [];

    for (var i = 0; i < campaigns.length; i++) {
      campaignsIds = [...campaignsIds, ...campaigns[i].list]
    }

    try {
      let response = await getHyreferralCampaignsPropertiesBreakdown(subOrgDetails.org.id, propertyIds, campaignsIds, monthRange.startAt, monthRange.endAt, status[0]);
      if (response.hyreferralCampaignsPropertiesBreakdown) {
        getOverviewData(response.hyreferralCampaignsPropertiesBreakdown, campaignsIds, propertyIds)
        setRows(getPropertiesRows(response.hyreferralCampaignsPropertiesBreakdown, classes, handleClickCampaign))
        setData(response.hyreferralCampaignsPropertiesBreakdown);
        setCsvData(getDataForCSV(response.hyreferralCampaignsPropertiesBreakdown))
        let _label = monthRange.label;
        if (monthRange.label === "Custom Range") {
          let start = moment(monthRange.startAt).format("D MMM YYYY");
          let end = moment(monthRange.endAt).format("D MMM YYYY");
          _label = start + " - " + end;
          if (start === end) {
            _label = start;
          }
        }
        setReportData({
          tabName: "By Property",
          params: JSON.stringify({
            property_ids: propertyIds,
            range_label: _label,
            report_type: "hyRaf_system_dashboard",
            start_date: moment(monthRange.startAt).format("YYYY/MM/DD"),
            end_date: moment(monthRange.endAt).format("YYYY/MM/DD"),
            org_id: subOrgDetails.org.id,
            campaigns_id: campaignsIds,
            active_status: status[0]
          }),
          type: "hyRaf_system_dashboard",
          month: _label
        })
        setLoading(false)
      }
    } catch (err) {
      console.log("Err", err)
    }
  }

  const getOverviewData = (list, campaignsIds, propertyIds) => {
    let campaignsCount = campaignsIds.length;
    let propertiesCount = propertyIds.length;
    let leasedCount = 0;
    let referredCount = 0;
    let enrollmentsCount = 0;

    for (let i = 0; i < list.length; i++) {
      leasedCount = leasedCount + parseInt(list[i].leasedCount);
      referredCount = referredCount + parseInt(list[i].friendsCount);
      enrollmentsCount = enrollmentsCount + parseInt(list[i].residentsCount);
    }
    setChartData({
      campaignsCount,
      propertiesCount,
      leasedCount,
      referredCount,
      enrollmentsCount
    })
  }

  const handleSort = (field, order) => {
    let sortedData = data.slice().sort((a, b) => compare(a[field], b[field], !order))
    setRows(getPropertiesRows(sortedData, classes, handleClickCampaign));
    setCsvData(getDataForCSV(sortedData));
  }


  const handleChangeProperty = (selected) => {
    setSelectedProperties(selected)
    setSelectedCampaigns([])
    setCampaignsForDropDown(getCampaignsByPropertyIdsSelected(selected, allCampaignsByProperties));
    getPropertyBreakDown(selected, [], monthRange, status)
  }

  const handleMonthRange = (time) => {
    setMonthRange(time);
    getPropertyBreakDown(selectedProperties, selectedCampaigns, time, status)
  }

  const handleChangeCampaigns = (selected) => {
    setSelectedCampaigns(selected)
    getPropertyBreakDown(selectedProperties, selected, monthRange, status)
  }

  const handleStatusChange = (values) => {
    setStatus(values)
    getPropertyBreakDown(selectedProperties, selectedCampaigns, monthRange, values)
  }

  const handleShowFilter = () => {
    setShowFilter(!showFilter)
  }

  const onClickNewCampaign = () => {
    history.push(getCreateEventPath());
  };

  const handleFilterProperty = (f, key) => {
    if (f) {
      let filteredData = data.slice().filter(item => {
        if (item[key]) {
          return item[key].toString().toLowerCase().includes(f.toLowerCase())
        }
      })
      setRows(getPropertiesRows(filteredData, classes, handleClickCampaign))
      setCsvData(getDataForCSV(filteredData))
    } else {
      setRows(getPropertiesRows(data, classes, handleClickCampaign))
      setCsvData(getDataForCSV(data));
    }
  }

  const handleFilter = (filterValue) => {
    if (filterValue && filterValue.id !== "All") {
      let filteredData = data.filter(e => e.active === (filterValue.id === "Active" ? true : false))
      setRows(getPropertiesRows(filteredData, classes, handleClickCampaign))
      setCsvData(getDataForCSV(filteredData))
    } else {
      setRows(getPropertiesRows(data, classes, handleClickCampaign))
      setCsvData(getDataForCSV(data))
    }
  }


  const handleDateFilter = (value) => {
    let filteredData = data.filter(e => getDate(e.createdAt) == getDate(value))
    setRows(getPropertiesRows(filteredData, classes, handleClickCampaign))
    setCsvData(getDataForCSV(filteredData))
  }
  return (
    <div>
      <PropertyFilterBar
        propertiesOfOrg={propertiesOfOrg}
        selectedProperties={selectedProperties}
        selectedCampaigns={selectedCampaigns}
        campaignsForDropDown={campaignsForDropDown}
        monthRange={monthRange}
        subOrgDetails={subOrgDetails}
        handleChangeProperty={handleChangeProperty}
        handleMonthRange={handleMonthRange}
        handleChangeCampaigns={handleChangeCampaigns}
        classes={classes}
        status={status}
        handleStatusChange={handleStatusChange}
        statusOption={statusOption}
        labelKey="Status"
      />
      <div>
        {loading ? <Loading /> :
          <>
            <Overview
              chartData={chartData}
              // monthRange={monthRange}
              // orgId={subOrgDetails.org.id}
              subMenu={subMenu}
              headerText="Org Overview"
            />
            <div className={classes.bottomViewProperty}>
              {
                (data.length == 0) ? <EmptyView handleButtonClick={onClickNewCampaign} message="No campaign is created yet. Create a new campaign now." image={EmptyViewCampaign} showButton={true} /> :
                  <div>
                    <TableHeader
                      title={`Breakdown - Properties (${propertiesOfOrg.length})`}
                      csvData={csvData}
                      csvHeaders={csvHeadersProperties}
                      fileName={`Breakdown - Properties (${propertiesOfOrg.length}).csv`}
                      showFilter={showFilter}
                      handleShowFilter={handleShowFilter}

                    />
                    <StyledTable
                      columns={getColumnsForProperties(classes, handleFilterProperty, handleDateFilter, tableStatusFilter, handleFilter, tableFilterOption)}
                      rows={rows}
                      sortHandler={handleSort}
                      className={classes.tableContainerRoot}
                      defaultSortBy="propertyName"
                      showFilter={showFilter}
                    />
                  </div>
              }
            </div>
          </>
        }
      </div>
    </div>
  )
}

export default ByProperty